import type { RawPetJson } from './types';
import nulaRaw from '@/assets/companions/nula/pet.json';
import nulaSheet from '@/assets/companions/nula/spritesheet.webp';
import keboRaw from '@/assets/companions/kebo/pet.json';
import keboSheet from '@/assets/companions/kebo/spritesheet.webp';
import bobaRaw from '@/assets/companions/boba/pet.json';
import bobaSheet from '@/assets/companions/boba/spritesheet.webp';

export interface CompanionEntry {
  id: string;
  raw: RawPetJson;
  spritesheet: string;
}

const COMPANIONS: CompanionEntry[] = [
  { id: 'nula', raw: nulaRaw as RawPetJson, spritesheet: nulaSheet },
  { id: 'kebo', raw: keboRaw as RawPetJson, spritesheet: keboSheet },
  { id: 'boba', raw: bobaRaw as RawPetJson, spritesheet: bobaSheet },
];

export const DEFAULT_COMPANION_ID = 'nula';

export function getCompanions(): CompanionEntry[] {
  return COMPANIONS;
}

export function getCompanion(id: string): CompanionEntry | undefined {
  return COMPANIONS.find((c) => c.id === id);
}
